module.exports = __webpack_public_path__ + "static/media/caretDownGeneric.2301ce1e.svg";